import React, { useState } from "react";
import { createData, fetchOnlyData } from "../../utility/adminApiv3";
import CancelIcon from "@mui/icons-material/Cancel";
import SelectLabels from "../../components/SelectLabels";
import { useQuery } from "@tanstack/react-query";

function AddBill({ setIsLoading, setAddtab, fetchBills, currentPage }) {
  const [formData, setFormData] = useState({
    name: "",
    percentage: "",
    description: "",
    is_active: "",
    bill_option_id: "",
  });
  const [loading, setLoading] = useState(false);

  const { data: autobill } = useQuery({
    queryKey: ["autobill"],
    queryFn: () => fetchOnlyData("auto-bills/bill-option"), // Call manually
    staleTime: 1000 * 60 * 50, // Keep fresh for 50 minutes
    cacheTime: 1000 * 60 * 60, // Cache for 60 minutes
    retry: 1,
    keepPreviousData: true,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const handleRowChange = (id) => {
    setFormData((prevData) => ({ ...prevData, is_active: id }));
  };

  const handleBillOptionId = (id) => {
    setFormData((prevData) => ({ ...prevData, bill_option_id: id }));
  };

  const handleChange = async (e) => {
    const { name, value } = e.target; // Destructure name and value from event target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value, // Update the corresponding field in state
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const data = new FormData();
    for (const key in formData) {
      data.append(key, formData[key]);
    }

    const response = await createData("auto-bills/store", formData);

    let errorCheck = response?.response?.data?.error;

    if (errorCheck) {
      setLoading(false);
    } else {
      fetchBills(currentPage);
      setLoading(false);
      setAddtab(false);
    }
    // navigate("/admin/manage");
  };

  return (
    <div className="bg-white  p-6 rounded-md">
      <div className="flex justify-end">
        <CancelIcon
          className="cursor-pointer"
          onClick={() => setAddtab(false)}
        />
      </div>
      <h3 className="text-2xl font-medium text-center">Add New Bill</h3>
      <form
        onSubmit={handleSubmit}
        className="py-12  flex flex-col justify-center items-center gap-6 "
      >
        <div className="flex flex-col flex-wrap justify-center lg:flex-row gap-6 ">
          <div className="flex  flex-col">
            <label htmlFor="">Name</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="Name"
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="">Percentage/Amount</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="Percentage/Amount"
              type="number"
              name="percentage"
              // id="email"
              value={formData.percentage}
              onChange={handleChange}
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="">Description</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="Description"
              type="text"
              name="description"
              // id="email"
              value={formData.description}
              onChange={handleChange}
              //   required
            />
          </div>

          <div className="flex flex-col lg:w-[400px]">
            <label htmlFor="">Status</label>
            <SelectLabels
              categoryData={[
                { id: 0, name: "Deactivate" },
                { id: 1, name: "Activate" },
              ]}
              text="Select"
              valueKey="id"
              labelKey="name"
              onSelectChange={handleRowChange}
            />
          </div>
          <div className="flex flex-col lg:w-[400px]">
            <label htmlFor="">Bill Type</label>
            <SelectLabels
              categoryData={autobill}
              text="Select"
              valueKey="id"
              labelKey="name"
              onSelectChange={handleBillOptionId}
            />
          </div>
        </div>
        <button
          type="submit"
          disabled={loading}
          className="px-4 py-3 text-white rounded-lg w-full lg:w-[400px] bg-blue-500 hover:bg-blue-600"
        >
          {loading ? "Adding Bill..." : "Add Bill"}
        </button>
      </form>
    </div>
  );
}

export default AddBill;
